import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M933.333 368.375C903.878 368.375 880 392.277 880 421.762C880 451.247 903.878 475.15 933.333 475.15C962.788 475.15 986.667 451.247 986.667 421.762C986.667 392.277 962.788 368.375 933.333 368.375Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 213.55H517.333V632.308H624V0H1600V747.424H516.667L234.126 1633.06L337.468 1665.34L596.094 854.199H1920L1729.66 1789.36C1714.51 1865.08 1647.52 1920 1570.48 1920H162.318C72.8265 1920 0 1847.1 0 1757.52V213.55ZM773.333 421.762C773.333 333.307 844.968 261.6 933.333 261.6C1021.7 261.6 1093.33 333.307 1093.33 421.762C1093.33 510.217 1021.7 581.925 933.333 581.925C844.968 581.925 773.333 510.217 773.333 421.762ZM1200 368.375H1466.67V475.15H1200V368.375Z",
  fillRule: "evenodd"
}));

var IconBankSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconBankSolid, _Component);

  var _super = _createSuper(IconBankSolid);

  function IconBankSolid() {
    _classCallCheck(this, IconBankSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconBankSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconBank",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconBankSolid.displayName = "IconBankSolid";
  return IconBankSolid;
}(Component);

IconBankSolid.glyphName = 'bank';
IconBankSolid.variant = 'Solid';
IconBankSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconBankSolid;
export { IconBankSolid };